import { Lock } from "lucide-react";
import React from "react";
import { Modal } from "@/components/_shared/Modal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface RaumPasswortProps {
	isOpen: boolean;
	onClose: () => void;
	passwort: string;
	onPasswortChange: (value: string) => void;
	onZugreifen: () => void;
	fehler?: string | null;
}

export function RaumPasswort({
	isOpen,
	onClose,
	passwort,
	onPasswortChange,
	onZugreifen,
	fehler,
}: RaumPasswortProps) {
	return (
		<Modal
			closeOnOutsideClick={false}
			isOpen={isOpen}
			onClose={onClose}
			title="Passwortgeschützter Raum"
		>
			<div className="space-y-4 p-2">
				<div className="mb-2 flex items-center rounded-lg border border-amber-100 bg-amber-50 p-3 text-amber-800 dark:border-amber-800/30 dark:bg-amber-900/30 dark:text-amber-300">
					<Lock className="mr-2 h-5 w-5 shrink-0" />
					<p>
						Dieser TextShare-Raum ist passwortgeschützt. Bitte gib das Passwort
						ein und klicke auf "Zugreifen".
					</p>
				</div>

				{fehler && (
					<p className="text-red-500 text-sm dark:text-red-400">{fehler}</p>
				)}

				<Input
					className="w-full"
					onChange={(e) => onPasswortChange(e.target.value)}
					onKeyDown={(e) => e.key === "Enter" && onZugreifen()}
					placeholder="Passwort eingeben"
					type="password"
					value={passwort}
				/>

				<div className="mt-4 flex justify-end space-x-2">
					<Button onClick={onClose} type="button" variant="outline">
						Abbrechen
					</Button>
					<Button onClick={onZugreifen} type="button">
						Zugreifen
					</Button>
				</div>
			</div>
		</Modal>
	);
}
